import React from 'react';
import PropTypes from 'prop-types';
import './leaf.css';

const Leaf = ({ className, children }) => (
  <div className={`leaf ${className}`}>
    <div className="ll" />
    <div className="text">{children}</div>
    <div className="rr" />
  </div>
);

Leaf.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};

Leaf.defaultProps = {
  className: '',
  children: {},
};

export default Leaf;



// WEBPACK FOOTER //
// ./src/blocks/HomeBlock/Leaf/index.js